import { nanoid } from 'nanoid';
import { getDB } from '../storage/db';
import { BAGS_TO_BLOCKS } from '../types/index';
import { sortByDateDesc } from '../utils/sort';
function assertValidBlocks(blocks) {
    if (!Number.isInteger(blocks) || (blocks !== 1 && blocks !== 2)) {
        throw new Error('Refill must be 1 or 2 blocks');
    }
}
async function getArrivedBlocks() {
    const db = await getDB();
    const items = await db.getAll('inventory');
    const arrivedBags = items.filter(i => i.status === 'arrived').reduce((sum, i) => sum + i.quantityBags, 0);
    return arrivedBags * BAGS_TO_BLOCKS;
}
export async function list() {
    const db = await getDB();
    const events = await db.getAll('refills');
    return sortByDateDesc(events);
}
export async function totalConsumedBlocks() {
    const db = await getDB();
    const events = await db.getAll('refills');
    const typed = events;
    return typed.reduce((sum, e) => sum + (Number.isFinite(e.blocks) ? e.blocks : 0), 0);
}
export async function create(blocks, date) {
    assertValidBlocks(blocks);
    const db = await getDB();
    // Prevent negative availability: arrived - consumed - new >= 0
    const [arrivedBlocks, consumedBlocks] = await Promise.all([
        getArrivedBlocks(),
        totalConsumedBlocks(),
    ]);
    const available = arrivedBlocks - consumedBlocks;
    if (blocks > available) {
        throw new Error(`Insufficient inventory: available ${available} blocks`);
    }
    const now = new Date();
    const event = {
        id: nanoid(),
        date: date ?? now.toISOString().slice(0, 10),
        blocks,
        createdAt: now.toISOString(),
    };
    await db.put('refills', event);
    // Auto-clear interim salt level readings on refill
    await db.clear('saltLevels');
    return event;
}
export async function remove(id) {
    const db = await getDB();
    await db.delete('refills', id);
}
export async function clear() {
    const db = await getDB();
    await db.clear('refills');
}
